import { type FC, type ReactNode } from "react";

import { Skeleton } from "@snapchat/snap-design-system";

interface StatSkeletonContainer {
    loading: boolean;
    children?: ReactNode;
}

export const StatSkeletonContainer: FC<StatSkeletonContainer> = ({ loading, children }) => {
    if (loading) {
        return <Skeleton height={50} />;
    }

    return <>{children}</>;
};
